import { Modality } from '../../models/task-types.model';

export const ApiRoutes = {
  BasePath: 'assistant/v1',
  Settings: {
    getClientSettings(): string {
      return `${ApiRoutes.BasePath}/client/settings`;
    },
  },
  TeamsToken: {
    getTeamsToken(): string {
      return `${ApiRoutes.BasePath}/client/teams/token`;
    },
  },
  Services: {
    getServicesMapping(): string {
      return `${ApiRoutes.BasePath}/client/teams`;
    },
    getServiceContext(): string {
      return `${ApiRoutes.BasePath}/client/teams/links/current`;
    },
    setServiceCallAttributes(): string {
      return `${ApiRoutes.BasePath}/client/teams/calls/attributes`;
    },
    getUserSessionsById(userId: string): string {
      return `${ApiRoutes.BasePath}/client/teams/users/${userId}/user-sessions`;
    },
    getCodesAndTags(teamId: string, conversationId: string, userSessionId: string): string {
      return `${ApiRoutes.BasePath}/client/teams/${teamId}/conversations/${conversationId}/user-sessions/${userSessionId}/codes`;
    },
    getContextParameters(teamId: string, conversationId: string, userSessionId: string): string {
      return `${ApiRoutes.BasePath}/client/teams/${teamId}/conversations/${conversationId}/user-sessions/${userSessionId}/parameters`;
    },
    getCallFlow(teamId: string, conversationId: string, userSessionId: string): string {
      return `${ApiRoutes.BasePath}/client/teams/${teamId}/conversations/${conversationId}/user-sessions/${userSessionId}/call-flow`;
    },
  },
  Calls: {
    startOutboundCall(): string {
      return `${ApiRoutes.BasePath}/client/teams/calls/outbound`;
    },
    blindTransfer(unifiedConversationId: string, conversationId: string, modality: Modality): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/blind-transfer?modality=${modality}`;
    },
    blindTransferToService(unifiedConversationId: string, conversationId: string, modality: Modality, target: string): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/blind-transfer-to-service?modality=${modality}&target=${target}`;
    },
    consultativeTransfer(unifiedConversationId: string, conversationId: string, user365Id: string): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call`;
    },
    mergeConsultationCall(unifiedConversationId: string, conversationId: string, user365Id: string, consultationCallId: string): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call/${consultationCallId}/merge`;
    },
    swapConsultationCall(unifiedConversationId: string, conversationId: string, user365Id: string, consultationCallId: string): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call/${consultationCallId}/swap`;
    },
    transferConsultationCall(unifiedConversationId: string, conversationId: string, user365Id: string, consultationCallId: string): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call/${consultationCallId}/transfer`;
    },
    terminateConsultationCall(
      unifiedConversationId: string,
      conversationId: string,
      user365Id: string,
      consultationCallId: string,
    ): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call/${consultationCallId}/terminate`;
    },
    hold(unifiedConversationId: string, user365Id: string): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/users/${user365Id}/hold`;
    },
    resume(unifiedConversationId: string, user365Id: string): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/users/${user365Id}/resume`;
    },
    terminateConsultationCallAndResume(
      unifiedConversationId: string,
      conversationId: string,
      user365Id: string,
      consultationCallId: string,
    ): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call/${consultationCallId}/terminate-and-resume`;
    },
    consultationCallToService(unifiedConversationId: string, conversationId: string, user365Id: string): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call-to-service`;
    },
    mergeConsultationCallToService(
      unifiedConversationId: string,
      conversationId: string,
      user365Id: string,
      consultationCallId: string,
    ): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call-to-service/${consultationCallId}/merge`;
    },
    swapConsultationCallToService(
      unifiedConversationId: string,
      conversationId: string,
      user365Id: string,
      consultationCallId: string,
    ): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call-to-service/${consultationCallId}/swap`;
    },
    transferConsultationCallToService(
      unifiedConversationId: string,
      conversationId: string,
      user365Id: string,
      consultationCallId: string,
    ): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call-to-service/${consultationCallId}/transfer`;
    },
    terminateConsultationCallToService(
      unifiedConversationId: string,
      conversationId: string,
      user365Id: string,
      consultationCallId: string,
    ): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call-to-service/${consultationCallId}/terminate`;
    },
    terminateConsultationCallToServiceAndResume(
      unifiedConversationId: string,
      conversationId: string,
      user365Id: string,
      consultationCallId: string,
    ): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/users/${user365Id}/consultation-call-to-service/${consultationCallId}/terminate-and-resume`;
    },
    safeTransfer(unifiedConversationId: string, conversationId: string, modality: Modality): string {
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/safe-transfer?modality=${modality}`;
    },
    safeTransferToService(unifiedConversationId: string, conversationId: string, modality: Modality, target: string): string {
      // In transfer endpoints like calls/{callId}/sessions/{sessionId}/safe-transfer-to-service, the frontend sends both IDs:
      // callId = unifiedConversationId
      // sessionId = conversationId (current service session)
      return `${ApiRoutes.BasePath}/client/calls/${unifiedConversationId}/sessions/${conversationId}/safe-transfer-to-service?modality=${modality}&target=${target}`;
    },
    park(callId: string, user365Id: string): string {
      return `${ApiRoutes.BasePath}/client/calls/${callId}/users/${user365Id}/park`;
    },
  },
  FeatureManagement: {
    isAllowTaskActivationWhileInActiveTaskEnabled(): string {
      return `${ApiRoutes.BasePath}/client/featureManagement/AllowTaskActivationWhileInActiveTask`;
    },
  },
  Nar: {
    getNotAvailableReasonRequests(): string {
      return `${ApiRoutes.BasePath}/client/agent/not-available-reasons`;
    },
    submitNotAvailableReason(): string {
      return `${ApiRoutes.BasePath}/client/agent/not-available-reason`;
    },
  },
  Session: {
    accept(callId: string, sessionsId: string, modality: Modality): string {
      return `${ApiRoutes.BasePath}/Client/calls/${callId}/sessions/${sessionsId}/task/accept?modality=${modality}`;
    },
    decline(callId: string, sessionsId: string, modality: Modality): string {
      return `${ApiRoutes.BasePath}/Client/calls/${callId}/sessions/${sessionsId}/task/decline?modality=${modality}`;
    },
    terminate(callId: string, sessionId: string, modality: Modality): string {
      return `${ApiRoutes.BasePath}/Client/calls/${callId}/sessions/${sessionId}/task/terminate?modality=${modality}`;
    },
  },
  AcsDriver: {
    getChatInfo(sessionId: string): string {
      return `acs-driver/v1/chat/sessions/${sessionId}/chat-info`;
    },
  },
  isApiAuthorizationNeeded(url: string): boolean {
    return url.indexOf(ApiRoutes.BasePath) >= 0 || url.indexOf('acs-driver/') >= 0;
  },
  Contacts: {
    search(): string {
      return `${ApiRoutes.BasePath}/Client/contacts/search`;
    },
    addressBookIcon(addressBookId: string): string {
      return `api/${ApiRoutes.BasePath}/Client/contacts/${addressBookId}/icon`;
    },
    graphUserIcon(userId: string): string {
      return `api/${ApiRoutes.BasePath}/Client/contacts/${userId}/photo`;
    },
  },
};
